var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content d-flex"},[_c('section',{staticClass:"pl-0"},[_c('h1',[_vm._v("View bills")]),(_vm.bills)?_c('div',[_c('p',{staticClass:"mb-8"},[_vm._v("These are bills for access to the API and/or SDK.")]),_c('BillsList',{attrs:{"bills":_vm.bills,"headers":_vm.headers}})],1):_c('div',[_c('p',[_vm._v("You have no bills.")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }